import React from 'react';
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton';
import HandCardImage from 'src/viewLayer/components/pages/Images/HandCard.svg';
import ScribbleImage from 'src/viewLayer/components/pages/Images/Scribble.svg';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { useBusinessPagePath, useEmailPagePath } from 'src/viewLayer/navigation';
import { namespaceT } from 'src/viewLayer/helpers/translations';
import { Stack, Box } from '@lessonnine/design-system.lib';
import {
  BusinessErrorPageWithBackground,
  BusinessErrorPageLayout,
  BusinessErrorCard,
  BusinessErrorCardTitle,
  BusinessErrorCardMessage,
  BackgroundItemsContainer
} from './index.styled';

const BackgroundItems = [HandCardImage, ScribbleImage];

export default function BusinessErrorPage({ appType }) {
  useTrackPageShown({ appType,  pageType: 'b2b_sso_error' });

  const isNativeMobileView = useAppConfigContext().devicePath === 'login-mobile';
  const nativeMobilePagePath = useBusinessPagePath();
  const webPagePath = useEmailPagePath();
  const pagePath = isNativeMobileView ? nativeMobilePagePath : webPagePath;

  const t = namespaceT('email.error.invalid_company_email');

  return (
    <BusinessErrorPageWithBackground>
      <BusinessErrorPageLayout
        alignItems="center"
        direction="stack"
        className="BusinessErrorPage"
        data-testid="business-error-page"
      >
        <BusinessErrorCard>
          <Box
            padding={{
              xxxsmall: [52, 20],
              xxsmall: [52, 20],
              xsmall: [55, 120],
              small: [55, 120]
            }}
          >
          <Stack gap={24} align="center" alignItems="center">
            <BusinessErrorCardTitle>{ t('title') }</BusinessErrorCardTitle>
            <BusinessErrorCardMessage>{ t('body') }</BusinessErrorCardMessage>
              <TrackableButton
                dataTestid="gotit-button"
                variant="secondary"
                title="Business error page CTA"
                trackingId="sso_error_gotit"
                href={ pagePath }
              >
                { t('cta') }
              </TrackableButton>
          </Stack>
          </Box>
        </BusinessErrorCard>
        <BackgroundItemsContainer>
          {BackgroundItems && BackgroundItems.map((BackgroundItem, index) => (
            <BackgroundItem key={index} />
          ))}
        </BackgroundItemsContainer>
      </BusinessErrorPageLayout>
    </BusinessErrorPageWithBackground>
  );
};
